var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPayicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.42263 13.0772C0.27886 12.5573 0.327659 10.9163 1.50029 10.4653L27.5454 0.447958C28.6912 0.00730374 29.8168 1.13304 29.3763 2.27876L19.3589 28.3239C18.9078 29.4965 17.2669 29.5452 16.747 28.4015L11.9581 17.8661L1.42263 13.0772ZM22.3319 5.48885L5.67202 11.8965L12.7204 15.1003L22.3319 5.48885ZM24.3353 7.49233L14.7238 17.1038L17.9277 24.1521L24.3353 7.49233Z",
    fill: "#C0C0C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayicon);
export default __webpack_public_path__ + "static/media/payicon.df144d49f6927b83f08f14606ac242a9.svg";
export { ForwardRef as ReactComponent };